import { AccordionField } from '@components/DrawerAccordion';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { ContactableCriteria } from '@/types/filterCriteriaRecords';

// These are the same as the final QFilter types
type HasPhone = 'any' | 'mobile' | 'landline';

type ContactableProps = {
  value: ContactableCriteria;
  onChange: (
    event: SelectChangeEvent,
    newValue: ContactableCriteria,
    reason: 'hasPhone' | 'hasEmail'
  ) => void;
};

const Contactable = ({ value = {} as ContactableCriteria, onChange }: ContactableProps) => {
  const handleChangePhone = (event: SelectChangeEvent) => {
    const newValue = { ...value };

    const selectValue = event.target.value as HasPhone | '';
    if (selectValue === '') {
      delete newValue.hasPhone;
    } else {
      newValue.hasPhone = selectValue;
    }
    onChange(event, newValue, 'hasPhone');
  };

  const handleChangeEmail = (event: SelectChangeEvent) => {
    const newValue = { ...value };

    const selectValue = event.target.value as 'yes' | 'no' | '';
    if (selectValue === '') {
      delete newValue.hasEmail;
    } else {
      newValue.hasEmail = selectValue === 'yes';
    }
    onChange(event, newValue, 'hasEmail');
  };

  return (
    <AccordionField>
      <Grid container spacing={2}>
        {/* A bit hacky because we aren't doing normal MUI labeling */}
        <Grid
          size={6}
          sx={{
            display: "flex",
            alignItems: "center"
          }}>
          <InputLabel id="contactable-hasPhone-label" sx={{ color: 'black' }}>
            Has phone
          </InputLabel>
        </Grid>
        <Grid size={6}>
          <FormControl fullWidth>
            <Select
              labelId="contactable-hasPhone-label"
              // We can't use null or undefined to represent 'blank' in the actual
              // Select because that will change it from controlled to uncontrolled
              value={value.hasPhone ?? ''}
              // label="Has phone"
              onChange={handleChangePhone}
            >
              <MenuItem value={''}>&nbsp;</MenuItem>
              <MenuItem value={'any'}>Any</MenuItem>
              <MenuItem value={'mobile'}>Mobile</MenuItem>
              <MenuItem value={'landline'}>Landline</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid
          size={6}
          sx={{
            display: "flex",
            alignItems: "center"
          }}>
          <InputLabel id="contactable-hasEmail-label" sx={{ color: 'black' }}>
            Has email
          </InputLabel>
        </Grid>
        <Grid size={6}>
          <FormControl fullWidth>
            <Select
              labelId="contactable-hasEmail-label"
              value={value?.hasEmail === true ? 'yes' : value.hasEmail === false ? 'no' : ''}
              // label="Has email"
              onChange={handleChangeEmail}
            >
              <MenuItem value={''}>&nbsp;</MenuItem>
              <MenuItem value={'yes'}>Yes</MenuItem>
              <MenuItem value={'no'}>No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </AccordionField>
  );
};

export default Contactable;
